export default "__VITE_ASSET__D2O65a1W__"